<h1 class="title">LTM Items</h1>
<h5>Manage Long-term Maintenance Items</h5>
<ng-container *ngIf="selectedProject && selectedProject.id else noActiveProject">
    <ng-container *ngIf="!isLoading else loadingView">
        <ng-container *ngIf="finEnabled else notEnabled">
            <h4 class="selected-project">Selected Project: {{selectedProject?.name}}</h4>
            <acabim-datatable
                    *ngIf="dataSources.length > 0"
                    [title]="selectedProject.name"
                    #ltmItemTable
                    [scrollable]="false"
                    [dataSources]="dataSources"
                    hasDetailView="true"
                    (details)="setDetails($event)"
                    (showDetail)="toggleStatus(true)"></acabim-datatable>
        </ng-container>
    </ng-container>
</ng-container>

<ng-template #notEnabled>
    <div class="cas-info">
        <p>The financial system must be enabled to use long-term maintenance items.</p>
    </div>
</ng-template>

<ng-template #loadingView>
    <acabim-loading-view></acabim-loading-view>
</ng-template>

<ng-template #projectErrorMessage>
    <div class="cas-error">
        <p>Please select a project to continue</p>
    </div>
</ng-template>

<ng-template #noActiveProject>
    <div class="cas-error">
        Please select a project to work with.
    </div>
</ng-template>

<ng-template [ngIf]="showAddModal">
    <acabim-modal
        [display]="true"
        fixHeight="60vh"
        width="60vw"
        (status)="toggleStatus($event)"
        [title]="modalTitle"
        [subtitle]="selectedItem?.maintenance_type_name">
        <acabim-admin-manage-budget-details [currentReport]="selectedItem" (closeModal)="showAddModal=false;"></acabim-admin-manage-budget-details>
    </acabim-modal>
</ng-template>
